import request from '@/utils/request'

/** 获取可用营销活动 */
export function getAvailableMarketing() {
  return request({
    url: '/enrollment/marketing/getAvailableMarketing',
    method: 'get'
  })
}
